module.exports = __webpack_public_path__ + "static/media/location.1fb24e18.svg";